import axios, { AxiosRequestConfig } from "axios";
import { checkAuthentication } from "../auth/AuthGuard";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "/api";
const API_AUTH_HEADER = process.env.REACT_APP_API_AUTH_HEADER || "";

export const baseURL = API_BASE_URL;

const axiosConfig: AxiosRequestConfig = { baseURL: API_BASE_URL };

if (process.env.NODE_ENV === "production") {
  axiosConfig.withCredentials = true;
} else {
  axiosConfig.headers = { Authorization: API_AUTH_HEADER };
}

export const axiosApi = axios.create(axiosConfig);

let authCheckInPromise: Promise<void> | null = null;

axiosApi.interceptors.response.use(
  (res) => res,
  async (error) => {
    const status = error?.response?.status;

    if (
      (status === 401 || status === 403) &&
      window.location.origin !== "http://localhost:3000"
    ) {
      if (!authCheckInPromise) {
        authCheckInPromise = checkAuthentication(undefined, {
          redirectOn401: true,
        }).finally(() => {
          authCheckInPromise = null;
        });
      }
      await authCheckInPromise;
    }

    return Promise.reject(error);
  },
);

axiosApi.interceptors.response.use((response) => {
  if (typeof response.data === "string") {
    response.data = response.data.replace(/^\)\]\}',\s*/, "");
    try {
      response.data = JSON.parse(response.data);
    } catch (_) {
      // leave as-is if it's not JSON
    }
  }
  return response;
});
